import axios from 'axios';

const resource = '/api/auth';

// Own instance, without the global interceptors: during the login the
// 401/403 answers are handled by the callback view, not by the
// "token expired" / generic error alerts.
const authApi = axios.create({
  baseURL: process.env.VUE_APP_API,
});

export default {
  // Full-page navigation: the backend redirects to Microsoft.
  // redirect_uri is this SPA's origin (no trailing slash), so the backend
  // sends the login code back here instead of to its configured FRONTEND_URL.
  // It must be listed in the backend FRONTEND_URLS allowlist, matched exactly.
  loginUrl() {
    const redirectUri = encodeURIComponent(window.location.origin);
    return `${process.env.VUE_APP_API}${resource}/login?redirect_uri=${redirectUri}`;
  },

  async createSession(code) {
    const response = await authApi.post(`${resource}/session`, { code });
    return response.data;
  },

  async getMe(accessToken) {
    const response = await authApi.get(`${resource}/me`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  },
};
